import PageLayout from "../../components/feature/PageLayout";
import InfoPageHero from "../../components/feature/InfoPageHero";
import InfoPageFinalCTA from "../../components/feature/InfoPageFinalCTA";
import InfoPageFooter from "../../components/feature/InfoPageFooter";
import ScrollReveal from "../../components/feature/ScrollReveal";
import { usePrivacyData } from "../../lib/useMockData";

export default function Privacy() {
  const { heroData, summaryText, sections, enactedDate } = usePrivacyData();
  return (
    <PageLayout>
      <InfoPageHero
        label={heroData.label}
        title={heroData.title}
        subtitle={heroData.subtitle}
        image={heroData.image}
        alt="プライバシーポリシー"
      />

      <section className="py-14 md:py-20 bg-airdoa-white">
        <div className="px-4 md:px-8 lg:px-12">
          <div className="max-w-3xl mx-auto">
            <ScrollReveal direction="up">
              <div className="mb-8 md:mb-10 pb-6 md:pb-8 border-b border-airdoa-gray-light">
                <p className="text-sm text-airdoa-gray leading-relaxed">
                  {summaryText}
                </p>
                <p className="mt-3 text-xs text-airdoa-gray-light">
                  制定日：{enactedDate}
                </p>
              </div>
            </ScrollReveal>

            <div className="flex flex-col gap-8 md:gap-10">
              {sections.map((section, idx) => (
                <ScrollReveal
                  key={section.title}
                  direction="up"
                  delay={idx * 60}
                >
                  <div>
                    <h2 className="text-base md:text-lg font-serif font-semibold text-airdoa-navy mb-3 flex items-center gap-2.5">
                      <span className="w-1 h-5 bg-airdoa-gold rounded-full shrink-0" />
                      {section.title}
                    </h2>
                    <div className="text-sm text-airdoa-gray leading-[1.9] whitespace-pre-line pl-3.5 border-l border-airdoa-gray-light/60">
                      {section.content}
                    </div>
                  </div>
                </ScrollReveal>
              ))}
            </div>
          </div>
        </div>
      </section>

      <InfoPageFinalCTA
        title={`ご不明な点がございましたら\nお気軽にお問い合わせください`}
        ctas={[
          {
            label: "お問い合わせページへ",
            href: "/contact",
            type: "primary",
          },
          { label: "FAQを見る", href: "/faq", type: "secondary" },
        ]}
      />

      <InfoPageFooter />
    </PageLayout>
  );
}